<template>
<div class="profit-loss-page">
  <div class="head_area">
    <div class="leftImg">
      <van-icon name="arrow-left" @click="$router.back()" />
    </div>
    <span class="head_text">{{ $t('输赢比例') }}</span>
    <span class="right_menu"></span>
  </div>
  <div class="content">
    <div class="profit-money">
      <div class="money">{{ info.win_total || 0 }}</div>
      <div class="date">
        {{date}}
        <div class="icon" @click="show = true">
          <van-icon name="notes-o" />
        </div>
      </div>
    </div>

    <div class="total-num">
      <div class="num-item">
        <div class="value">{{ info.win_total || 0 }}</div>
        <div class="label">{{ $t('盈利总额') }}</div>
      </div>
      <div class="num-item">
        <div class="value">{{ info.recharge_total || 0 }}</div>
        <div class="label">{{ $t('充值总额') }}</div>
      </div>
      <div class="num-item">
        <div class="value">{{ info.withdraw_total || 0 }}</div>
        <div class="label">{{ $t('提现总额') }}</div>
      </div>
      <div class="num-item">
        <div class="value">{{ info.bet_total || 0 }}</div>
        <div class="label">{{ $t('投注总额') }}</div>
      </div>
    </div>
  </div>

  <van-calendar v-model="show" @confirm="onConfirm"
                color="#1989fa"
                :min-date="new Date(1900, 0, 1)"
                :max-date="current_date" />

</div>
</template>

<script>
import { getCurrentDay, formatDate } from "@/common/utils"
export default {
  name: 'profit-loss',
  data(){
    return {
      info: {

      },
      current_date: new Date(),
      date: getCurrentDay(),
      show: false,
    }
  },
  mounted() {
    this.getInfo()
  },
  methods: {
    back(){
      window.history.go(-1)
    },
    getInfo() {
      this.$parent.showLoading();
      this.$apiFun.post('/api/dailyReport', { date: this.date }).then(res => {
        this.info = res
        this.$parent.hideLoading();
      }).catch(err => {
        this.$parent.hideLoading();
      });
    },
    onConfirm(date) {
      this.show = false;
      this.date = formatDate(date);
      this.getInfo()
    },
  },
}
</script>

<style scoped lang="scss">
.profit-loss-page {
  position: relative;
  width: 100%;
  height: 100vh;
  background-color: #000;
  color: #fff;
  font-family: PingFang SC;
  background-image: url("/static/image/new/page-bg-img.png");
  background-size: cover;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  .head_area {
    position: relative;
    z-index: 2;
    height: 1.33333rem;
    display: flex;
    align-items: center;
    padding: 0 .4rem;
    .leftImg {
      flex: 1;
      text-align: left;
      font-size: .48rem;
    }
    .top_back {
      width: 0.26rem;
      height: 0.37333rem;
    }
    .head_text {
      font-size: 0.50667rem;
      color: #fff;
      width: 55%;
      text-align: center;
    }
    .right_menu {
      font-size: 0.37333rem;
      color: #fff;
      flex: 1;
      text-align: right;
    }
  }
  .content {
    flex: 1;
    overflow: auto;
    position: relative;
    z-index: 2;
    padding: 0 .4rem;
    .profit-money {
      position: relative;
      z-index: 2;
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 1.36rem;
      background: rgba(255, 255, 255, 0.10);
      border: 0.03rem solid rgba(255, 255, 255, 0.10);
      border-radius: .27rem;
      padding: 0 .32rem;
      .money {
        font-family: Gilroy;
        font-size: .69rem;
      }
      .date {
        display: flex;
        align-items: center;
        margin-top: .1rem;
        font-size: .32rem;
        color: #BBBBBB;
        .icon {
          font-size: .45rem;
          margin-left: .2rem;
        }
      }
    }
    .total-num {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      width: 100%;
      border-radius: .2rem;
      box-sizing: border-box;
      margin-top: .37rem;
      .num-item {
        width: 2.11rem;
        height: 1.92rem;
        border-radius: .27rem;
        flex-shrink: 0;
        margin-bottom: .75rem;
        background: rgba(255, 255, 255, 0.10);
        border: 0.03rem solid rgba(255, 255, 255, 0.10);
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        border-bottom: .27rem;
        .label {
          font-size: .32rem;
          color: #BBBBBB;
          margin-top: .27rem;
        }
        .value {
          font-size: .48rem;
          font-family: Gilroy;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mode/ProfitLoss.vue